import React from "react";
import { OTPInput } from "../FormElements";
import { PrimaryButton } from "../Cta";
import { Link } from "react-router-dom";

export default function OtpModal(props) {
  return (
    <div className=" position-fixed top-0 start-0 e-bg-modal min-h-100vh min-vw-100 d-flex align-items-center justify-content-center">
      <div className="row w-100">
        <div className="offset-lg-4 col-lg-4">
          <div className="bg-white e-border-radius-24 e-p-20px">
            <div className="d-flex justify-content-start flex-column align-items-center ">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h5 className=" text-start e-font-weight-600 e-font-20 line-height-32px e-primary-font-poppins m-0">
                  Verify your PAN via OTP
                </h5>
                <PrimaryButton
                  icon="close-button"
                  name=""
                  size="12px"
                  ClassName="bg-white"
                  onPress={props.close}
                />
              </div>

              <p className="e-primary-font-poppins e-font-14 e-font-weight-400">
                Submit the OTP sent to your mobile number linked with Aadhaar to
                complete PAN verification.
              </p>

              <div className="d-flex flex-column w-100   justify-content-start">
                <OTPInput
                  label="Enter OTP"
                  labelStyle="w-100 text-start e-font-16 e-font-weight-400"
                  ref={props.otpInputRef}
                  id="otp"
                  value={props.otpValue}
                  spellcheck="false"
                  error={props.otpError}
                  require={true}
                  focused_input={props.focusedInput}
                  confirm_pin={props.confirmOTP}
                  onFocus={() => props.setFocusedInput(2)}
                  onBlur={() => props.setFocusedInput(0)}
                  onKeyPress={props._handleSubmitOTP}
                  onChange={props._handleOTP}
                />
                <Link
                  to="/"
                  className="text-decoration-none pt-3 e-font-weight-400 e-font-14 e-text-dark-silver d-flex align-items-center e-cursor-pointer pb-3"
                  onClick={(e) => {
                    e.preventDefault();
                    props._handleOTP({ target: { value: "" } });
                  }}
                >
                  Didn’t get code yet?
                  <span className="ps-2 e-text-blue-violet e-font-weight-500 e-font-14">
                    Resend OTP
                  </span>
                </Link>
                <div className="row e-pt-24px">
                  <div className="col-12">
                    <PrimaryButton
                      ClassName="e-border-radius-pill e-font-weight-500 py-3 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
                      name="Verify"
                      onPress={props._handleSubmitOTP}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
